import IconBase from './IconBase'
import { ReactComponent } from './light/cog.svg'

const Icon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default Icon
